import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import MuiTextField from '@material-ui/core/TextField';
import { createStyles, withStyles } from '@material-ui/styles';
import { transition } from '@topconagriculture/theme';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import cn from 'classnames';
import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import { compose, pure, withHandlers, withState } from 'recompose';
import { ActionIcon } from '../../ActionIcon';
export const renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const matches = match(suggestion.value, query);
    const parts = parse(suggestion.value, matches);
    return (React.createElement(MenuItem, { button: false, selected: isHighlighted, component: 'div' },
        React.createElement("div", null, parts.map((part, index) => part.highlight ? (React.createElement("span", { key: String(index), style: { fontWeight: 500 } }, part.text)) : (React.createElement("strong", { key: String(index), style: { fontWeight: 300 } }, part.text))))));
};
export const autocompleteStyles = (theme) => createStyles({
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.space.margin.small,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        backgroundColor: theme.color.background.light,
    },
    inputWrapper: {
        position: 'relative',
        width: '100%',
    },
    inputField: {
        paddingRight: theme.space.padding.default,
        width: '100%',
    },
    selectArrow: {
        position: 'absolute',
        left: '85%',
        top: theme.space.margin.default,
        transform: 'rotate(-90deg)',
        cursor: 'pointer',
        transition: transition(),
    },
    selectArrowOpened: {
        transform: 'rotate(90deg)',
    },
});
const Autocomplete = (props) => {
    const { suggestions, placeholder, classes, value, label, theme, onSuggestionsFetchRequested, onSuggestionsClearRequested, suggestionsList, onChange, selectOpened, setSelectOpened, setSelectOpenedHandler, getSuggestionValueHandler, testId = 'Autocomplete', } = props;
    const inputProps = {
        classes,
        placeholder,
        label,
        value,
        onChange,
    };
    inputProps.onBlur = () => {
        return setSelectOpened(false);
    };
    const listHasElements = suggestionsList.length > 0;
    return (React.createElement(Autosuggest, { "data-testid": `${testId}`, suggestions: suggestions, onSuggestionsFetchRequested: onSuggestionsFetchRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValueHandler, focusInputOnSuggestionClick: false, renderSuggestion: renderSuggestion, alwaysRenderSuggestions: selectOpened, shouldRenderSuggestions: (val) => {
            return selectOpened || val.length > 0;
        }, inputProps: inputProps, renderSuggestionsContainer: (options) => (React.createElement(Paper, Object.assign({}, options.containerProps, { square: true }), options.children)), renderInputComponent: ({ classes: componentClasses, ...iProps }) => (React.createElement("div", { className: classes.inputWrapper },
            React.createElement(MuiTextField, Object.assign({ "data-testid": `${testId}-input` }, iProps)),
            listHasElements && (React.createElement(ActionIcon, { "data-testid": `${testId}-opener`, onClick: setSelectOpenedHandler(!selectOpened), className: cn(classes.selectArrow, selectOpened && classes.selectArrowOpened), color: theme.color.font.dark, iconName: 'chevron-left', iconSize: 12 })))), theme: {
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
            input: classes.inputField,
        } }));
};
export default compose(withStyles(autocompleteStyles, { withTheme: true }), pure, withState('suggestions', 'setSuggestions', (props) => props.suggestionsList), withState('selectOpened', 'setSelectOpened', false), withHandlers({
    setSelectOpenedHandler: (props) => (newState) => () => {
        props.setSelectOpened(newState);
    },
    getSuggestionValueHandler: () => (sugg) => {
        return sugg.value;
    },
    getSuggestionsHandler: (props) => (searchString) => {
        const searchStringValue = searchString && searchString.trim().toLowerCase();
        const searchStringValueLength = searchStringValue.length;
        const suggListFound = searchStringValueLength === 0
            ? []
            : props.suggestionsList.filter(({ value: suggestion }) => {
                const suggestionToSearchIn = suggestion && suggestion.trim().toLowerCase();
                return suggestionToSearchIn.indexOf(searchStringValue) > -1;
            });
        props.setSelectOpened(suggListFound.length > 0);
        return suggListFound;
    },
}), withHandlers({
    onSuggestionsFetchRequested: (props) => ({ value }) => {
        props.setSuggestions(props.getSuggestionsHandler(value));
    },
    onSuggestionsClearRequested: (props) => () => {
        props.setSuggestions([]);
    },
}))(Autocomplete);
//# sourceMappingURL=Autocomplete.js.map